import { Box, Button, Stack, Typography } from '@mui/material';
import { Icon } from '@shared/icons';
import { Product } from '@domain/product/models/Product';

interface UnclassifiedProductRowProps {
  product: Product;
  onAdd: () => void;
}

const UnclassifiedProductRow = ({ product, onAdd }: UnclassifiedProductRowProps) => (
  <Stack direction="row" alignItems="center" spacing={2}>
    {product.image && <Box component="img" src={product.image} alt="" sx={{ width: 36, height: 36, objectFit: 'contain' }} />}
    <Typography variant="body2" noWrap sx={{ flex: 1, minWidth: 0 }}>{product.title}</Typography>
    <Typography variant="body2" color="text.secondary" noWrap>SKU: {product.sku || '—'}</Typography>
    <Typography variant="body2" color="text.secondary" noWrap>EAN: {product.ean || '—'}</Typography>
    <Button size="small" variant="text" startIcon={<Icon icon="Plus01" />} onClick={onAdd}>
      Add
    </Button>
  </Stack>
);

export default UnclassifiedProductRow;
